import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
const Contact = () => {
   return (
      <>
         <Card className='contact-card'>
            <Card.Body>
               <div className="contact-slider">
                  <div className="contact-item">
                     <p>Available For Hire 🚀 Crafting Digital Experiences 🎨 Available For Hire 🚀 Crafting Digital Experiences 🎨</p>
                  </div>
               </div>
               <Card.Title as="h2">
                  Let's Work Together!
               </Card.Title>
               <Link to='/contact' className="link-btn">
                  Let's Talk <span data-icon="arrow-turn"></span>
               </Link>
            </Card.Body>
         </Card>
     </>
   )
 }

 export default Contact;